import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CartService } from '@draeger-academy/common';
import { CoursesService } from '@draeger-academy/common/lib/services/courses/courses.services';
import { OrderService } from '@draeger-academy/common/lib/services/order/order.service';
import { UrlService } from '@draeger-academy/common/lib/services/url/url.service';
import { Course } from 'models/course';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

@Component({
    selector: 'da-booking-confirmation',
    templateUrl: './booking-confirmation.component.html',
    styleUrls: ['./booking-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookingConfirmationComponent implements OnInit {
    @Input() activeStep: number;

    @Output()
    nextStep: EventEmitter<string> = new EventEmitter<string>();
    private _order: Subscription;
    private _$events: BehaviorSubject<any> = new BehaviorSubject([]);
    public get events$(): Observable<Course[]> {
        return this._$events.asObservable();
    }

    constructor(
        private orderService: OrderService,
        public _urlService: UrlService,
        public _coursesService: CoursesService,
        public _cartService: CartService
    ) {}

    ngOnInit() {
        // this.orderService.order$.subscribe((order) => {
        //     if (order && order.cartItems && order.cartItems.length > 0) this._$events.next(order.cartItems);
        // });
        let cartItems;
        if (localStorage.getItem('eventsHotels') && this._urlService.decode(localStorage.getItem('eventsHotels'))) {
            cartItems = JSON.parse(this._urlService.decode(localStorage.getItem('eventsHotels')));
        }

        this._coursesService.getItemsFromCart(cartItems).then((data) => {
            if (data && data.length > 0) {
                this._$events.next(data);
                localStorage.removeItem('eventsHotels');
            }
        });
    }

    public isActive(currentStep: number) {
        if (currentStep < Number(this.activeStep)) {
            return true;
        }
    }

    public isCurrent(currentStep: number) {
        if (currentStep === Number(this.activeStep)) {
            return true;
        }
    }

    goToStep(number) {
        this.nextStep.emit(number);
    }

    ngOnDestroy() {
        this.orderService.updateOrder(null);
        if (this._order) {
            this._order.unsubscribe();
        }
    }
}
